// @flow

import * as React from "react";
import _ from "lodash";
import { withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";

import actions from "../actions/index.js";
import HeroProfilePage from "../components/organisms/HeroProfilePage";
import CustomMeta from "../components/atoms/CustomMeta.js";
import ComponentBuilder from "../components/organisms/ComponentBuilder";

type PropsType = {
    page: any,
};

const AccountContent = (props: PropsType): React.Node => {
    const dispatch = useDispatch();
    const { page } = props;
    const components =
        _.get(page, "acf.component_builder.component_builder") || [];

    const breadcrumbs = [
        {
            title: "My account",
            onClick: () => dispatch(actions.openAccountModal()),
            type: "button",
        },
    ];

    return (
        <React.Fragment>
            <CustomMeta title={page.post_title} />

            <HeroProfilePage
                heading={page.post_title}
                prependBreadcrumbs={breadcrumbs}
                breadcrumbs={props.breadcrumbs}
                customBreadcrumbs={props.customBreadcrumbs}
            />

            <div>
                <div className="page-content page-content--account">
                    <ComponentBuilder components={components} />
                </div>
            </div>
        </React.Fragment>
    );
};

AccountContent.preload = ({
    location,
    passed: { store },
}: any): Promise<any> => {
    return Promise.all([]);
};

export default withRouter(AccountContent);
